import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";
import EventDetailsSection from "../../components/SupportPage/EventDetailsSection";
import PreArrivalSupportSection from "../../components/SupportPage/PreArrivalSupportSection";
import HotelAssistanceSection from "../../components/SupportPage/HotelAssistanceSection";
import NetworkingSection from "../../components/SupportPage/NetworkingSection";
import EngagementActivitiesSection from "../../components/SupportPage/EngagementActivitiesSection";
import ImportantNoteSection from "../../components/SupportPage/ImportantNoteSection";
import ContactSupportSection from "../../components/SupportPage/ContactSupportSection";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import "../../components/SupportPage/SupportPage.scss";

const SupportPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Support | Cash Flow Summit 2026</title>
        <meta
          name="description"
          content="Outstation participant support for Cash Flow Summit 2026: travel guidance, hotel assistance, on-ground coordination, networking support, and important event information."
        />
        <meta
          name="keywords"
          content="Cash Flow Summit support, outstation participant support, travel help, hotel assistance, event facilities"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"Outstation Participant Support & Facilities"} pagesub={"Support"} />
      
      <section className="section-padding" style={{ paddingTop: "80px" }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <SectionTitle
                title="Cash Flow Summit 2026 – New Delhi"
                titleStyle={{ color: "#252686" }}
                paragarap="We understand that traveling from another city comes with planning, concerns, and questions. To make your experience smooth, safe, and stress-free, JSA provides complete digital support and coordination for all outstation participants attending the Cash Flow Summit 2026."
                paragraphStyle={{ color: "#525252" }}
              />
            </div>
          </div>
        </div>
      </section>

      <EventDetailsSection />
      <PreArrivalSupportSection />
      <HotelAssistanceSection />
      <NetworkingSection />
      <EngagementActivitiesSection />
      <ImportantNoteSection />
      <ContactSupportSection />

      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};

export default SupportPage;

